import * as uuid from 'uuid';

const createUid = () => {
  return uuid.v4();
};

export default createUid;
